<template>
    <md-dialog
            :md-click-outside-to-close="false"
            :md-close-on-esc="false"
            @keydown.esc="updateIsChangingStatus"
            :md-active.sync="show_order_status_change">
        <md-toolbar >
            <div class="md-title md-layout md-gutter md-alignment-center-left" style="width: inherit">
                <div class="md-layout-item" style="padding-left: inherit">
                    Update Porting Order #{{ order.porting_order_number }}
                </div>
                <div class="md-layout md-alignment-center-right">
                    <md-button class="md-primary md-layout-item md-size-10"
                               @click="updateIsChangingStatus"
                               :md-ripple="false"
                               >
                        <md-icon>close</md-icon>
                    </md-button>
                </div>
            </div>
        </md-toolbar>
        <md-dialog-content>
            <form v-loading="current_requests.length === 0">
                <div class="md-layout" style="display: grid; padding: 5px">
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Comments</label>
                                    <md-textarea v-model="updateOrderStatusForm.comments"></md-textarea>
                                </md-field>
                            </div>
                        <div v-if="order_status === 'FOCDateApproved'" class="md-layout md-gutter" >
                            <div class="md-layout-item">
                                <el-date-picker
                                        v-model="updateOrderStatusForm.foc_date"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :disabled="executing_update.status"
                                        placeholder="FOC Date"
                                        :picker-options="pickerOptions">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
            </form>
        </md-dialog-content>
        <md-dialog-actions class="md-layout" style="padding-top: 10px">
            <el-button
                    class="md-size-25 md-layout-item"
                    :disabled="executing_update.status"
                    @click="updateIsChangingStatus"
                    type="danger"
            >Cancel
            </el-button>
            <el-button
                    class="md-size-25 md-layout-item"
                    :disabled="!isFormValid()"
                    :loading="executing_update.status"
                    @click="updateStatus"
                    type="success"
            >Update
            </el-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "OrderStatusChangeModal",
        props: ['show_order_status_change', 'order', 'order_status', 'type'],
        data() {
            return {
                updateOrderStatusForm: {
                    comments: "",
                    foc_date: null
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    },
                }
            }
        },
        methods: {
            updateIsChangingStatus: function () {
                this.$emit('update:show_order_status_change', !this.show_order_status_change)
            },
            updateStatus() {
                let payload = {
                    id: this.order.id,
                    status: this.order_status,
                    type: this.type,
                }
                if (this.order_status === "FOCDateApproved") {
                    payload['foc_date'] = this.updateOrderStatusForm.foc_date
                }
                if (this.updateOrderStatusForm.comments) {
                    payload['comments'] = this.updateOrderStatusForm.comments
                }
                this.$store.dispatch('orders/patchOrder', payload)
            },
            isFormValid() {
                if (this.order_status === "Rejected" && !this.updateOrderStatusForm.comments) {
                    return false;
                }
                if (this.order_status === "FOCDateApproved" && !this.updateOrderStatusForm.foc_date) {
                    return false;
                }
                return true;
            },
            clearForm() {
                this.updateOrderStatusForm.comments = ""
                this.updateOrderStatusForm.foc_date = null
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                executing_update: state => state.orders.executing_update,
                current_requests: state => state.orders.current_requests,
                notification: state => state.orders.notification,
            }),
        },
        watch: {
            executing_update: function (newVal, oldVal) {
                if (newVal.status === false && oldVal.status === true && this.notification.type === 'success') {
                    this.updateIsChangingStatus()
                    this.$store.dispatch('orders/setCurrentRequests', [])
                    this.clearForm()
                }
            },
            show_order_status_change: function (newVal, oldVal) {
                if (oldVal === false && newVal === true) {
                    this.$store.dispatch('orders/getRequests', {porting_order_id: this.order.id})
                } else {
                    this.$store.dispatch('orders/setCurrentRequests', [])
                    this.clearForm();
                }
            },
            current_requests: function (newVal) {
                if (!this.show_order_status_change) return;
                if (newVal.length > 0) {
                    this.updateOrderStatusForm.foc_date = this.current_requests[0].requested_foc_date;
                }
            }
        },
    }
</script>

<style scoped>
    .md-dialog {
        width: 50%;
        max-width: 95%;
    }

    .md-dialog /deep/ .md-dialog-container {
        transform: none;
    }

    .md-dialog /deep/ .md-dialog-content {
        padding: 5px;
    }

    .md-list-item {
        height: 65px;
    }

    form {
        padding: 10px;
    }

    .el-input /deep/ .el-input__inner {
        border-color: gray
    }

    .el-input /deep/ .el-input__prefix {
        color: gray
    }

    .el-header, .el-footer {
        background-color: rgb(244, 244, 244);
        line-height: 60px;
        font-size: 16px;
        color: #4F4D4C
    }

    .el-main {
        padding-top: 0;
        padding-bottom: 10px;
    }

    .el-container {
        border: 1px solid #EBEEF5;
    }

    button {
        font-weight: 500;
    }

</style>